import {HttpClient} from '@angular/common/http';
import {environment} from './../../environments/environment';
import {Injectable} from '@angular/core';
import {UserInfo} from '../models/user/userInfo';
import {UserSettings} from '../models/user/userSettings';
import {Role} from '../models/user/role';
import {UserNotification} from '../models/user/userNotification';
import {User} from '../models/user/user';
import {Supplier} from '../models/supplier/supplier';
import {UserDeputy} from '../models/user/userDeputy';
import { Partnership } from '../models/partnership/partnership';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private apiPartialEndpoint = environment.apiEndPoint + '/api/v1/user';
  private apiEndpointData = environment.apiEndPoint + '/api/v1/data';
  userInfo;

  constructor(private http: HttpClient) {
  }

  getUsers() {
    return this.http.get<UserInfo[]>(this.apiPartialEndpoint);
  }

  searchUsers(pattern: string) {
    return this.http.get<UserInfo[]>(this.apiPartialEndpoint + '/search'
      , {params: {s_pattern: pattern}});
  }

  getUserInfo() {
    return this.http.get<UserInfo>(this.apiPartialEndpoint + '/roles');
  }

  getAllUserRoles() {
    return this.http.get<Role[]>(this.apiEndpointData + '/user/role' + '?just_project_roles=false');
  }

  getUserNotifications() {
    return this.http.get<UserNotification[]>(this.apiPartialEndpoint + '/notification');
  }

  saveUserNotification(notification: UserNotification) {
    return this.http.put(this.apiPartialEndpoint + '/notification', notification);
  }

  saveAllUserNotification() {
    return this.http.patch(this.apiPartialEndpoint + `/notification`, '');
  }

  getAllUsers() {
    return this.http.get(this.apiPartialEndpoint + `/users`);
  }

  editUser(userId: number, user: any) {
    return this.http.put(this.apiPartialEndpoint + `/users/${userId}`, user);
  }

  copyUserAssignments(body: any) {
    return this.http.post(this.apiPartialEndpoint + `/permission/clone`, body);
  }

  getUserStatus() {
    return this.http.get(this.apiEndpointData + `/user/status`);
  }

  getUserRoles(userId: number) {
    return this.http.get(this.apiPartialEndpoint + `/${userId}/projectroles`);
  }

  getUsersAndRoles() {
    return this.http.get<UserInfo[]>(this.apiPartialEndpoint + "/users/roles");
  }

  getAccessUsersAndRoles() {
    return this.http.get<UserInfo[]>(this.apiPartialEndpoint + "/accessusers/roles");
  }

  removeUsersAssignments(userId: number, roleId: number) {
    return this.http.delete(this.apiPartialEndpoint + `/users/${userId}/role/${roleId}`);
  }

  getProjectRoles(userId: number) {
    return this.http.get(this.apiPartialEndpoint + `/${userId}/projectroles`)
  }

  updateUsersDeputy(body: UserDeputy) {
    return this.http.post(this.apiPartialEndpoint + `/deputy`, body);
  }

  updateOrSaveUser(user: User) {
    return this.http.put(this.apiPartialEndpoint, user);
  }

  getUserSettings(id: number) {
    return this.http.get(this.apiPartialEndpoint + `/settings/${id}`);
  }

  saveUserSettings(userId: number, userSettings: UserSettings) {
    return this.http.put(this.apiPartialEndpoint + `/` + userId + `/settings`, userSettings);
  }

  getSupplierPartnerships() {
    return this.http.get<Partnership[]>(this.apiPartialEndpoint + `/supplierpartnerships`);
  }

  inviteSupplierUserToPropla(supplier: Supplier) {
    return this.http.post(this.apiPartialEndpoint + `/supplierinvitation`, supplier);
  }
}
